/**
 * Card de "Top sectores históricos" — primera tarjeta de Capa 2.
 *
 * Muestra hasta 5 sectores con el % de la captación total + monto en
 * COP. Visual con barra horizontal proporcional al porcentaje. Si el
 * backend devuelve la lista vacía (muni sin SGR), no renderiza nada.
 */

import { Layers } from "lucide-react";

import { type HistoricalSectorDTO } from "@/lib/api";

import { bigIntFromCop, formatCop } from "./_shared";

export function TopHistoricalSectors({ items }: { items: HistoricalSectorDTO[] }) {
  if (items.length === 0) {
    return null;
  }
  return (
    <div
      data-testid="ficha-top-sectors"
      className="rounded-2xl border border-slate-200 bg-white p-5 shadow-xs"
    >
      <div className="flex items-start gap-2">
        <Layers className="mt-0.5 h-4 w-4 text-brand-600" aria-hidden="true" />
        <div className="flex-1">
          <h2 className="text-sm font-bold text-slate-900">Top sectores históricos</h2>
          <p className="mt-0.5 text-xs text-slate-500">
            Distribución de la captación SGR por sector (toda la historia).
          </p>
        </div>
      </div>
      <ul className="mt-4 space-y-3">
        {items.map((item) => {
          const cop = bigIntFromCop(item.total_captacion_cop);
          return (
            <li key={item.sector} data-testid="ficha-top-sectors-item" className="space-y-1">
              <div className="flex items-baseline justify-between gap-3">
                <span className="text-xs font-medium text-slate-800 capitalize" title={item.sector}>
                  {item.sector.toLowerCase()}
                </span>
                <span className="text-xs font-semibold text-slate-700 tabular-nums">
                  {item.pct.toFixed(0)}%{" "}
                  <span className="font-normal text-slate-500">· {formatCop(cop)}</span>
                </span>
              </div>
              <div className="h-1.5 overflow-hidden rounded-full bg-slate-100">
                <div
                  className="h-full bg-brand-500"
                  style={{ width: `${Math.min(100, item.pct)}%` }}
                />
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
